export default {
    ca: {},
    es: {},
    en: {},
};



// WEBPACK FOOTER //
// ./src/map-viewer/map-viewer-translations.js